import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import AkiraPictogram from "../../assets/akira_pictogram.svg";
import styles from "./bot.module.css";
import { botName, BotResponse, Citation, CosmosDBStatus, ErrorMessage, getListAvailableAgents, createNewConversationNew, historyRead } from '../../api';
import { Answer } from '../../components/Answer';
import { CommandBarButton, Dialog, DialogType, IconButton, Stack } from "@fluentui/react";
import { ShieldLockRegular, ErrorCircleRegular } from "@fluentui/react-icons";
import uuid from 'react-uuid';
import { useBoolean } from '@fluentui/react-hooks';
import { AppStateContext } from '../../state/AppProvider';
import { QuestionInput } from '../../components/QuestionInput';
import { ChatHistoryPanel } from '../../components/ChatHistory/ChatHistoryPanel';
import * as AdaptiveCards from 'adaptivecards';
import 'adaptivecards/dist/adaptivecards.css';
import AdaptiveCardRenderer from '../../components/AdaptiveCards/AdaptiveCard';
import ReactMarkdown from 'react-markdown';
import DOMPurify from 'dompurify';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { XSSAllowTags } from '../../constants/xssAllowTags';
import Tile from '../../components/Prompts/Tiles';
import { AvailableAgentsList, BotConversation, UserInfo, UserMessage } from '../../api/models'
import { useMsal } from "@azure/msal-react";
import { useLocation, useNavigate,  useParams, useSearchParams } from 'react-router-dom';
import { ApiPostFunctionRequest, AvailableParameters, BotChatProps, ChoicesChoiceSet, fetchInputs, KeyValuePair, PortfolioInsightsPayload, TileData } from './interfaces';
import { createUserInfoList, decodeToken, getCurrentTimestamp, getDropdownLabel, getTeamsAuthToken, handleChatHistoryDeleted, isJson, modalProps, onViewSource, parseCitationFromMessage, parseCitations, setAccessTokenInLocalStorage, setEmailInLocalStorage, setUserIdInLocalStorage } from './common';
import AutoCompleteCard from '../../components/AutoCompleteCard/AutoCompleteCard';
import { messageStatus, initialTilesData, agentMode, promptMappings, constants } from './constants';
import { useLogoNavigationLink } from '#/state';
import { useClientSource } from '#/hooks/useClientSource';
import { mapDataSourceToAgent, mapAgentNameToAccessDeniedErrorMessage } from './utils';
import { useDocumentTitle } from '#/hooks/useDocumentTitle';
import { FilePreview } from '#/components/FilePreviewPanel';
import { trackAuthEvent, trackAuthException } from '../../utils/telemetry';
import { config } from '#/config'
import { agentHasFeature, FeatureFlag } from '#/constants/agentFeatures';
import {  Group as PanelGroup, Panel, Separator } from 'react-resizable-panels';


const bot: React.FC<BotChatProps> = ({ isTeams }) => {
  console.log('[BotChat] Component mounted. isTeams:', isTeams, 'In iframe:', window.self !== window.top)

  const { agent } = useParams<{ agent: string }>();
  const [searchParams] = useSearchParams();
  const conversationIdFromUrl = searchParams.get('conversationId');
  const navigate = useNavigate();
  const location = useLocation();
  const insightsSchema = useRef<string[]>([]);
  const [availableOptions, setAvailableOptions] = useState<AvailableParameters>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [messages, setMessages] = useState<BotResponse[]>([])
  const [ASSISTANT, TOOL, ERROR] = ["assistant", "tool", "error"]
  const [showLoadingMessage, setShowLoadingMessage] = useState<boolean>(false);
  const chatMessageStreamEnd = useRef<HTMLDivElement | null>(null);
  const [processMessages, setProcessMessages] = useState<messageStatus>(messageStatus.NotRunning);
  const appStateContext = useContext(AppStateContext)
  const ui = appStateContext?.state.frontendSettings?.ui;
  const AUTH_ENABLED = appStateContext?.state.frontendSettings?.auth_enabled;
  const [activeCitation, setActiveCitation] = useState<Citation>();
  const [isCitationPanelOpen, setIsCitationPanelOpen] = useState<boolean>(false);
  const abortFuncs = useRef([] as AbortController[]);
  const [showAuthMessage, setShowAuthMessage] = useState<boolean | undefined>();
  const [clearingChat, setClearingChat] = useState<boolean>(false);
  const [hideErrorDialog, { toggle: toggleErrorDialog }] = useBoolean(true);
  const [errorMsg, setErrorMsg] = useState<ErrorMessage | null>()
  const [onLoad, setOnLoad] = useState(true);
  const [conversationId, setConversationId] = useState<string>('')
  const [activeQuestion, setActiveQuestion] = useState<string>('')
  const [directLineToken, setDirectLineToken] = useState<string>('');
  const [bot_Name, setBotName] = useState<string>()
  const [onHoverChat, setHoverNewChat] = useState(false);
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [isSignInMessageReceived, setSignInMessage] = useState(false);
  const [isSubscribed, setSubscription] = useState(false);
  const [isPageLoad, setPageLoad] = useState(true);
  const [isHistoryLoading, setHistoryLoading] = useState(false);
  const [isStructuredQuery, setStructuredQuery] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<string>('')
  const [isDataInitialized, setIsDataInitialized] = useState<boolean>(false);
  const [tilesData, setTilesData] = useState<TileData[]>(initialTilesData);
  const [userId, setUserId] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [accessToken, setAccessToken] = useState<string>('');
  const [isInitialized, setIsInitialized] = useState(false);
  const [notAuthorized, setIsNotAuthorized] = useState(false);
  const [userRoles, setRoles] = useState<string[]>();
  const [tokenExpiry, setTokenExpiry] = useState(0);
  const [fetchInputs, setFetchInputs] = useState<fetchInputs | undefined>(undefined);
  const [autocompleteOptions, setAutocompleteOptions] = useState<string[]>([]);
  const [autocompleteValue, setAutocompleteValue] = useState<string>('');
  const abortControllerRef = useRef<AbortController | null>(null);
  const scrollableRef = useRef<HTMLDivElement | null>(null);
  const [loadingText, setLoadingText] = useState("Generating answer...");
  const { disableLogoNavigationLink, enableLogoNavigationLink } = useLogoNavigationLink();
  const { getClientSource } = useClientSource();
  const { setDefaultDocumentTitle, setDocumentTitle } = useDocumentTitle();
  const previousChatRef = useRef<any>(null);
  const [showAllTiles, setShowAllTiles] = useState<boolean>(false);
  const agentRedirect = config.env.NEW_ARCHITECT_LIVE

  let assistantMessage = {} as BotResponse
  let assistantContent = ""

  useEffect(() => {
    if (!selectedAgent) {
      return;
    }

    // For TrafoChat agent there is a requirement to "trap" user and prevent him from leaving the chat
    // We are disabling logo navigation link, and enabling it on any different agent.
    switch(selectedAgent.toLowerCase()) {
      case constants.agent.trafochat:
        disableLogoNavigationLink();
        setDocumentTitle("Akira TrafoChat");
      break;
      default:
        enableLogoNavigationLink();
        setDefaultDocumentTitle();
    }
  }, [selectedAgent]);

  // Add this new useEffect to handle loading from history
  useEffect(() => {
    if (!agent || !conversationId) return;
    
    const historyState = location.state as any;
    
    if (historyState?.messages && Array.isArray(historyState.messages)) {
      console.log('🔄 Loading messages from history navigation state');
      
      // Set conversation ID
      setConversationId(conversationId);
      localStorage.setItem("conversation_id", conversationId);
      
      // Set the data source and title
      if (historyState.dataSource) {
        setStorageDataSource(historyState.dataSource);
      }
      if (historyState.conversationTitle) {
        localStorage.setItem("title", historyState.conversationTitle);
      }
      
      // Transform messages from historyRead API format to BotResponse format
      const transformedMessages: BotResponse[] = historyState.messages.map((msg: any) => ({
        id: msg.id || uuid(),
        role: msg.role || 'assistant',
        content: msg.content || '',
        date: msg.createdAt || new Date().toISOString(),
        feedback: msg.feedback || undefined,
        type: msg.type || 'message',
        timestamp: msg.timestamp || '',
        channelId: msg.channelId || '',
        from: msg.from || { id: '', name: '' },
        conversation: msg.conversation || { id: conversationId, title: historyState.conversationTitle || '', messages: [], date: '' },
        text: msg.content || '',
        inputHint: msg.inputHint || '',
        context: msg.context || '',
        messageType: msg.messageType || 'text',
        card: msg.card || undefined,
        token: msg.token || directLineToken,
        streamUrl: msg.streamUrl || '',
        MessageCategory: msg.MessageCategory
      }));
      
      setMessages(transformedMessages);
      ScrollToBottom();
      
      // Mark page load as complete
      setPageLoad(false);
      setOnLoad(false);
    }
  }, [agent, conversationId, location.state]);

  useEffect(() => {
    if (!agent || !conversationIdFromUrl) {
      console.warn('⚠︝ Missing agent or conversationId in URL params. agent:', agent, 'conversationIdFromUrl:', conversationIdFromUrl);
      return
    };

    console.log('clearing messages', messages.length, 'for agent:', agent, 'conversationId:', conversationIdFromUrl);

    setMessages([]); // Clear messages when agent or conversationId changes
      appStateContext?.dispatch({ 
      type: 'UPDATE_CURRENT_CHAT', 
      payload: null 
    });

    console.log('🔄 Loading history - agent:', agent, 'conversationId:', conversationIdFromUrl, 'messages:', messages);
    
    if (accessToken && isInitialized) {
      console.log('📥 Fetching from API');
      setHistoryLoading(true);
      
      const fetchHistoryMessages = async () => {
        try {
          const response = await historyRead(conversationIdFromUrl, '', '', accessToken) as any;
          const historyMessages = Array.isArray(response) ? response : response?.messages;

          if (historyMessages) {
            const transformedMessages: BotResponse[] = historyMessages.map((msg: any) => ({
              id: msg.id || uuid(),
              role: msg.role || 'assistant',
              content: msg.content || '',
              date: msg.createdAt || new Date().toISOString(),
              feedback: msg.feedback || undefined,
              type: msg.type || 'message',
              timestamp: msg.timestamp || '',
              channelId: msg.channelId || '',
              from: msg.from || { id: '', name: '' },
              conversation: msg.conversation || { id: conversationIdFromUrl, title: '', messages: [], date: '' },
              text: msg.content && typeof msg.content === 'string' ? msg.content : (msg.content?.body?.[0]?.text || ''),
              inputHint: msg.inputHint || '',
              context: msg.context || '',
              messageType: msg.messageType || 'text',
              card: msg.type === 'adaptiveCard' && msg.content ? msg.content : (msg.card || undefined),
              token: msg.token || directLineToken,
              streamUrl: msg.streamUrl || '',
              MessageCategory: msg.MessageCategory
            }));
            
            setMessages(transformedMessages);
            setConversationId(conversationIdFromUrl);
            localStorage.setItem("conversation_id", conversationIdFromUrl);
            setPageLoad(false);
            setOnLoad(false);
          }
        } catch (err) {
          console.error('❌ Error fetching history:', err);
        } 
        finally {
          // setIsDataInitialized(true);
          setHistoryLoading(false);
        }
      };
      
      fetchHistoryMessages();
    }
  }, [agent, conversationIdFromUrl, accessToken, isInitialized]);

  useEffect(() => {
    const initialize = async () => {
      // In iframe mode with injected token, skip AUTH_ENABLED check and use token directly
      if (window.self !== window.top) {
        if (AUTH_ENABLED === undefined) return; 

        console.log('[IframeAuth:bot] Iframe mode detected — skipping AUTH_ENABLED check');
        let attempts = 0;
        const maxAttempts = 10;
        while (!sessionStorage.getItem('akira_injected_token') && attempts < maxAttempts) {
          console.log(`[IframeAuth:bot] Waiting for injected token... (attempt ${attempts + 1}/${maxAttempts})`);
          await new Promise(resolve => setTimeout(resolve, 100));
          attempts++;
        }
        if (attempts >= maxAttempts) {
          console.warn('[IframeAuth:bot] Timeout waiting for injected token');
        }

        localStorage.removeItem("dataSource");
        sessionStorage.removeItem("dataSource");
        localStorage.removeItem("title");

        // Use injected token directly — do NOT use MSAL or AUTH_ENABLED
        await getUserInfoListForMsal(instance);
        await GetDirectLineToken(false);
        localStorage.setItem('isSignInCodeReceived', JSON.stringify(true));
        setIsInitialized(true);
        return;
      }

      // Non-iframe mode: use normal AUTH_ENABLED logic
      localStorage.removeItem("dataSource");
      sessionStorage.removeItem("dataSource");
      localStorage.removeItem("title");

      if (AUTH_ENABLED !== undefined) {
        localStorage.clear();
        if (isTeams) {
          await getUserInfoListForTeams();
        } else {
          await getUserInfoListForMsal(instance);
        }
        await GetDirectLineToken(false);

        localStorage.setItem('isSignInCodeReceived', JSON.stringify(true));

        setIsInitialized(true);
      }
    };

    initialize();
  }, [AUTH_ENABLED]);

  const getTileByTitle = (title: string) => {
    const tile = initialTilesData.find((tile) => tile.title === title);
    return tile;
  };

  const isResetableAgent = Boolean(selectedAgent) && selectedAgent !== constants.mappedAgent.unstructured;

  const resetChatOrNavigateMainPage = (agent: string) => {
    if (isResetableAgent) {
      const datasource = getStorageDataSource();
      const tile = tilesData.find(t => t.title === agent || t.content === agent) ||
                  tilesData.find(t => promptMappings[t.content] === datasource);
      if (tile) handleSwitchAgentTiles(tile);
    } else {
      newChat();
    }
  }
  
  // Fetch tile configuration for NEW badges
  const fetchTileConfig = async () => {
    try {
      console.log('🔝 [NEW Badge] Fetching /tile-config.json...');
      const response = await fetch('/tile-config.json');
      console.log('📡 [NEW Badge] Response:', { status: response.status, ok: response.ok });
      if (response.ok) {
        const config = await response.json();
        console.log('✅ [NEW Badge] Config loaded:', config);
        console.log('🎨 [NEW Badge] Badge config:', config.newBadges);
        return config.newBadges || {};
      } else {
        console.warn('⚠︝ [NEW Badge] Response not OK, status:', response.status);
      }
    } catch (error) {
      console.error('❌ [NEW Badge] Failed to load tile configuration:', error);
    }
    return {};
  };

  // Apply NEW badge configuration to tiles
  const applyNewBadgeConfig = async (tiles: TileData[]) => {
    
    const badgeConfig = await fetchTileConfig();
    
    const result = tiles.map(tile => {
      const isNew = badgeConfig[tile.title] === true;
      return {
        ...tile,
        isNew: isNew
      };
    });
  
    return result;
  };

  useEffect(() => {
    if (!isInitialized || !userRoles) return;

    const normalizedAgent = agent?.trim().toLocaleLowerCase();

    console.log('🔝 [NEW Badge] useEffect - isInitialized:', isInitialized, 'userRoles:', userRoles);
    console.log('🔑 [NEW Badge] useEffect - accessToken:', accessToken ? 'EXISTS (length: ' + accessToken.length + ')' : 'MISSING/EMPTY');

    const isPGGA = normalizedAgent === constants.agent.pgga || normalizedAgent === constants.agent.pggall;
    const isTrafochat = normalizedAgent == constants.agent.trafochat;
    const isDigitalCore = normalizedAgent == constants.agent.sapCoe;
    const isCCRP = normalizedAgent == constants.agent.ccrp;
    const isReasoning = normalizedAgent == "reasoning";
    const isROR = normalizedAgent == constants.agent.ror;
    const isLegalNuclear = normalizedAgent === "nuclear_legal";
    const isSwitchInsightUnstructured = normalizedAgent === constants.agent.pghv;
    const isSwitchInsightStructured =  normalizedAgent === constants.agent.pghvDatabases;
    const isPmcert = normalizedAgent === constants.agent.pmcert;
    const isZaragoza = normalizedAgent === constants.agent.zaragoza;
    const isHSEIncident = normalizedAgent === constants.agent.hseincident;
    const isGRCM = normalizedAgent === constants.agent.grcm;
    const isProjectManagement = normalizedAgent === 'digital_core_pm';
    const isGeneral = normalizedAgent === constants.agent.unstructured || normalizedAgent === 'general';

    const isUserPGGAProject = userRoles.includes('user.PGGA_Project');
    const isUserEngineeringProject = userRoles.includes('user.Engineering_Project');
    const isUserDigitalCore = userRoles.includes('user.Sap_Coe');
    const isUserCCRP = userRoles.includes('user.CCRP_Project');
    const isUserROR = userRoles.includes('user.RoR');
    const isUserLegalNuclear = userRoles.includes('user.LI_Project');
    const isUserSwitchInsight = userRoles.includes('user.PGHV_Project');
    const isUserPmcert = userRoles.includes('user.PMCert_Project');
    const isUserZaragoza = userRoles.includes('user.Zaragoza');
    const isUserHSEIncident = userRoles.includes('user.hse_incident');
    const isUserProjectManagement = userRoles.includes('user.SAPCoE_Project');

    if (isGeneral && isAuthenticated) {
      console.log('✅ Loading General/Unstructured agent');
      // For general, we don't have a tile, so set it up directly
      setSelectedAgent(constants.agent.unstructured);
      setStorageDataSource(constants.agent.unstructured);
      setIsLoading(false);
      setShowLoadingMessage(false);
      setStructuredQuery(true);
      setIsDataInitialized(true);
    }

    if (isCCRP && isAuthenticated) {
      if (isUserCCRP) {
        handleCardClick(getTileByTitle(constants.mappedAgent.ccrp));
      } else {
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if(isROR && isAuthenticated){
      if(isUserROR){
        handleCardClick(getTileByTitle("RoR Platform"));
      }else{
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if(isLegalNuclear && isAuthenticated){
      if(isUserLegalNuclear){
        handleCardClick(getTileByTitle("Nuclear Legal"));
      }else{
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if(isSwitchInsightUnstructured && isAuthenticated){
      if(isUserSwitchInsight){
        handleCardClick(initialTilesData.find(tile => tile.content === "HV Products and Services"));
      }else{
        updateNotAuthMsg(normalizedAgent);
      }
    }
    if(isGRCM && isAuthenticated){
        handleCardClick(getTileByTitle("GRC Platforms"));
    }

    if(isSwitchInsightStructured && isAuthenticated){
      if(isUserSwitchInsight){
        handleCardClick(initialTilesData.find(tile => tile.content === "PGHV Databases"));
      }else{
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if(isReasoning && isAuthenticated){
      handleCardClick(getTileByTitle("Reasoning"));
    }


    if (isPGGA && isAuthenticated) {
      if (isUserPGGAProject) {
        handleCardClick(getTileByTitle("PGGA Insights"));
      } else {
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if (isTrafochat && isAuthenticated) {
      if (isUserEngineeringProject) {
        handleCardClick(getTileByTitle(constants.mappedAgent.pgtrEngineering));
      } else {
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if (isDigitalCore && isAuthenticated) {
      if (isUserDigitalCore) {
        handleCardClick(getTileByTitle("Digital Core CoE"));
      } else {
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if (isPmcert && isAuthenticated) {
      if (isUserPmcert) {
        handleCardClick(getTileByTitle(constants.mappedAgent.pmcert));
      } else {
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if (isZaragoza && isAuthenticated) {
      if (isUserZaragoza) {
        handleCardClick(getTileByTitle("Zaragoza Engineering"));
      } else {
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if (isHSEIncident && isAuthenticated) {
      if (isUserHSEIncident) {
        handleCardClick(getTileByTitle("HSE Incident"));
      } else {
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if (isProjectManagement && isAuthenticated) {
      if (isUserProjectManagement) {
        handleCardClick(getTileByTitle("Digital Core"));
      } else {
        updateNotAuthMsg(normalizedAgent);
      }
    }

    if(normalizedAgent === undefined){
      fetchAgents();
    }
  }, [isInitialized, agent, isAuthenticated, userRoles]);

  useEffect(() => {
    const controller = new AbortController();
    if (fetchInputs != undefined) {
      setShowLoadingMessage(true);
      setIsLoading(true);

      const run = async (controller: AbortController, inputs: fetchInputs) => {
        fetch(inputs.input, { ...inputs.init, signal: controller.signal })
          .then(async (response) => await consumeTheResponse(response))
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted');
            } else {
              console.error('Fetch error:', error);
            }
          })
          .finally(() => {
            setProcessMessages(messageStatus.Done);
            setIsLoading(false);
            setShowLoadingMessage(false);
            ScrollToBottom();
            setFetchInputs(undefined);
          });
      };

      run(controller, fetchInputs);
    }
    return () => {
      controller.abort();
    };
  }, [fetchInputs]);


  const fetchAgents = async () => {
    try {
      console.log('🚀 [NEW Badge] fetchAgents called, accessToken:', !!accessToken);
      
      if (accessToken) {
        const availableAgents = await getListAvailableAgents(accessToken);    
        
        const typedAgents = availableAgents as AvailableAgentsList;

        console.log(typedAgents);

        if (typedAgents) {

          const updatedTilesData = updateAgentsTiles(typedAgents, tilesData);

          const projectInsightTile = updatedTilesData.find((tile: TileData) => tile.title === "Project Data Insights");
          const ccrpTile = updatedTilesData.find((tile: TileData) => tile.title === "CCRP");
          const projectNavigatorTile = updatedTilesData.find((tile: TileData) => tile.title === "Project Navigator");

          if (projectInsightTile && !projectInsightTile.shouldBeDisabled) {
            // Project Insights is available - give it priority 1
            projectInsightTile.sortOrder = 1;
            // If both are available, CCRP gets 4
            if (ccrpTile && !ccrpTile.shouldBeDisabled) {
              ccrpTile.sortOrder = 4;
            }
          }

          if (projectNavigatorTile && !projectNavigatorTile.shouldBeDisabled) {
            // Project Navigator should immediately follow Project Insights (priority 2)
            projectNavigatorTile.sortOrder = 1.5;
          }

          const updatedTilesData2 = [...updatedTilesData].sort((a, b) => {
            if (a.shouldBeDisabled !== b.shouldBeDisabled) {
                return Number(a.shouldBeDisabled) - Number(b.shouldBeDisabled);
            }
            return a.sortOrder - b.sortOrder;
          });

          // console.log('📦 [NEW Badge] Before badge config:', updatedTilesData2.map(t => ({ title: t.title, isNew: t.isNew })));
          
          // Apply NEW badge configuration
          const tilesWithBadges = await applyNewBadgeConfig(updatedTilesData2);
          
          // console.log('✨ [NEW Badge] After badge config:', tilesWithBadges.map(t => ({ title: t.title, isNew: t.isNew })));
          
          setTilesData(tilesWithBadges);

        }
        setIsDataInitialized(true);
      } else {
        console.warn('⚠︝ [NEW Badge] fetchAgents called but no accessToken');
      }
    } catch (err) {
      console.error('❌ [NEW Badge] Error in fetchAgents:', err);
    } finally {

    }
  };

  const updateAgentsTiles = (agentsList: any, tilesData: any) => {

    const updatedTilesData = tilesData.map((tile: any) => {
      if (tile.title === "PGGA Insights") {
        if (agentsList.agents_availability.pgga === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.title === "PGTR Engineering" || tile.title === constants.mappedAgent.pgtrEngineering) {
        if (agentsList.agents_availability.pgtr_engineering === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.title === "Project Data Insights") {
        if (agentsList.agents_availability.structured === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.title === constants.mappedAgent.ccrp) {
        if (agentsList.agents_availability.ccrp === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.content === "HV Products and Services") {
        if (agentsList.agents_availability.pghv === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.content === "PGHV Databases") {
        if (agentsList.agents_availability.pghv_structure === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }else if (tile.content === "Project Management") {
        if (agentsList.agents_availability.sap_coe === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.content === "SAP Processes and Information") {
        if (agentsList.agents_availability.digital_core_coe === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.content === "VEE-G5 Technology") {
        if (agentsList.agents_availability.ror === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.content === "Your Virtual Nuclear Counsel") {
        if (agentsList.agents_availability.lc_nuclear === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.title === "Reasoning") {
        if (agentsList.agents_availability.gpt5_gk === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.title === "HV Project") {
        if (agentsList.agents_availability.hv_project_tracker === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (tile.title === "PM Certification") {
        if (agentsList.agents_availability.pmcert === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if (
        tile.title === constants.mappedAgent.scm ||
        tile.title === constants.mappedAgent.finance
      ) {
        return { ...tile, shouldBeDisabled: false };
      }else if (tile.title === "HVDC Academy") {
        if (agentsList.agents_availability['hvdc-learn'] === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }else if(tile.title === "Zaragoza Engineering"){
        if (agentsList.agents_availability.zaragoza === 'available') {
            return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }else if (tile.title === "Project Navigator") {
        if (agentsList.agents_availability['project_navigator'] === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if(tile.title === "HSE Incident"){
        if (agentsList.agents_availability.hse_incident === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if(tile.title === "Taiju"){
        if (agentsList.agents_availability['taiju'] === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else if(tile.title === "GRC Platforms"){
        if (agentsList.agents_availability.grcm === 'available') {
          return { ...tile, shouldBeDisabled: false };
        }
        else {
          return { ...tile, shouldBeDisabled: true };
        }
      }
      else {
        return { ...tile, shouldBeDisabled: true };
      }
});
    console.log('updatedTilesData :>> ', updatedTilesData);
    return updatedTilesData;
  }

  const errorDialogContentProps = {
    type: DialogType.close,
    title: errorMsg?.title,
    closeButtonAriaLabel: 'Close',
    subText: errorMsg?.subtitle,
  };

  interface TextBlock { type: string; text: string; size: string, weight: string }

  const { instance } = useMsal();

  const updateNotAuthMsg = (agent?: string) => {
    console.log("agent Name: ", agent);

    const mappedAgentName = mapDataSourceToAgent(agent) ?? agent;
    const errorResponseMessage = mapAgentNameToAccessDeniedErrorMessage(mappedAgentName);

    let errorChatMsg: BotResponse = {
      id: uuid(),
      role: ERROR,
      content: errorResponseMessage,
      date: new Date().toISOString(),
      feedback: undefined,
      type: 'message',
      timestamp: '',
      channelId: '',
      from: {
        id: '',
        name: ''
      },
      conversation: {
        id: '',
        title: '',
        messages: [],
        date: ''
      },
      text: '',
      inputHint: '',
      context: '',
      messageType: 'error',
      card: undefined,
      token: '',
      streamUrl: ''
    }

    setMessages([...messages, errorChatMsg].filter((value, index, self) => self.indexOf(value) === index))
    ScrollToBottom();
    setIsNotAuthorized(true);
    setIsDataInitialized(true);
    setIsLoading(false);
    setShowLoadingMessage(false);

  }

  const renderAdaptiveCard = (objAdaptiveCard: any, conId: string, messageId?: string, messageCategory?: string) => {

    const adaptiveCard = new AdaptiveCards.AdaptiveCard();
    adaptiveCard.parse(objAdaptiveCard);
    adaptiveCard.hostConfig = new AdaptiveCards.HostConfig({ supportsMarkdown: true });
    const renderedCard = adaptiveCard.render();
    if (renderedCard && renderedCard.innerText.includes("OTP Statistics by Category")) {
      const elements = renderedCard.querySelectorAll('[style*="flex: 1 1 25%"]');
      elements.forEach(el => {
        (el as HTMLElement).style.flex = "1 1 30%";
      });
    }
    if (renderedCard?.hasChildNodes) {
      let response: BotResponse = {
        role: "assistant",
        card: objAdaptiveCard,
        feedback: undefined,
        type: 'adaptiveCard',
        id: messageId ?? '',
        timestamp: '',
        date: '',
        channelId: '',
        from: { id: '', name: '' },
        conversation: { id: '', title: '', messages: [], date: '' },
        text: '',
        inputHint: '',
        context: '',
        content: objAdaptiveCard,
        messageType: 'card',
        token: directLineToken,
        streamUrl: '',
        MessageCategory: messageCategory
      };
      if (objAdaptiveCard.body) {
        const textBlock = objAdaptiveCard.body.find((item: TextBlock) => item.type === 'TextBlock');
        if (textBlock) {
          response.text = textBlock.text;
        } else {
          response.text = "image";
        }
      }

      const cardExists = messages.some(msg => JSON.stringify(msg.card) === JSON.stringify(objAdaptiveCard));

      if (!cardExists) {
        messages.push(response);
        setMessages([...messages]);
      }

      ScrollToBottom();
    }
  };

  useEffect(() => {
    if (chatMessageStreamEnd?.current) {

        chatMessageStreamEnd?.current?.scrollIntoView({ behavior: 'smooth' });

    }
  }, [messages]);

  const parseCitationFromMessage = (message: BotResponse) => {
    if (message?.role && message?.role === "tool") {
      try {

        const toolMessage = JSON.parse(message.content);
        return toolMessage;
      }
      catch {
        return [];
      }
    }
    return [];
  }

  useLayoutEffect(() => {
    const fetchData = async () => {
      if (appStateContext && processMessages === messageStatus.Done) {
        setProcessMessages(messageStatus.NotRunning);
      }
    };

    fetchData();
  }, [processMessages]);

  useEffect(() => {
    if(conversationIdFromUrl) return;

    if (appStateContext?.state.currentChat) {
      const response = appStateContext.state.currentChat.messages as unknown as BotResponse[];
      const newMessages = [...response];
      const transformedMessages = newMessages.map(m => {
        return m;
      });
      setStorageDataSource(appStateContext?.state?.currentChat?.dataSource);
      setMessages(transformedMessages);
      ScrollToBottom();
    } else {
      setStorageDataSource('');
      setMessages([]);
      ScrollToBottom();
    }
    setFetchInputs(undefined);
  }, [appStateContext?.state.currentChat]);

  const onShowCitation = (c: Citation): void => {
    setActiveCitation(c);
    setIsCitationPanelOpen(true);
  }

  useLayoutEffect(() => {
    chatMessageStreamEnd.current?.scrollIntoView({ behavior: "smooth" })
  }, [showLoadingMessage, processMessages, fetchInputs ]);

  const onHoverNewChat = () => {

    if (!disabledButton()) {
      setHoverNewChat(true);

      const element = document.getElementById('tooltipchat');

      if (element) {
        element.style.position = 'absolute';
        element.style.background = '#e8e9e6';
        element.style.padding = '8px';
        element.style.left = '50px';
      }
    }
  };

  const disabledButton = () =>
    isLoading || (messages && messages.length === 0) || clearingChat || notAuthorized;

  const handleHistoryItemRemoved = (item: BotConversation) => {
    // In theory, this condition is always true becouse clicking on "trash" icon on the history list, triggers loading of the chat history,
    // So there is no way remove a chat that you are not looking at.
    if (item.id === conversationId) {
      handleChatHistoryDeleted(isTeams, messages, setAvailableOptions, handleCreateConversation, () => resetChatOrNavigateMainPage(selectedAgent));
    }
  }

  const newChat = () => {
    // We can't rely on value calculated globaly, becouse it might dissapear when new chat created
    // const isResetable = Boolean(selectedAgent) && selectedAgent !== constants.mappedAgent.unstructured;

    setSelectedAgent('');
    setShowLoadingMessage(false);
    setConversationId('');
    setIsLoading(false);
    setFetchInputs(undefined);
    if(isTeams){
      localStorage.removeItem("dataSource");
    }else{
      sessionStorage.removeItem("dataSource");
    }
    localStorage.removeItem("title");
    localStorage.removeItem("historylistConId");
    setAvailableOptions(undefined);
    console.log("Closing Conversation.. Con ID =" +localStorage.getItem('conversationId'));
    // directLine.end();
    GetDirectLineToken(true)
    appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: null });

    // if (!isResetable) {
    //   navigate('/');
    // }
  };

  const onLeaveNewChat = () => {
    setHoverNewChat(false);
    const element = document.getElementById('tooltipchat');

    if (element) {
      element.style.background = 'transparent';
    }
  };

  const handleErrorDialogClose = () => {
    toggleErrorDialog()
    setTimeout(() => {
      setErrorMsg(null)
    }, 500);
  }

  const showMainPage = () => {

    console.log("showMainPage called.")

    setMessages([]);
    messages.length = 0;
    setPageLoad(true);
    setSubscription(false);
    handleCloseCitationPanel();

    setProcessMessages(messageStatus.Done)

    console.log("showMainPage ended.")
  }

 
const ScrollToBottom = () => {
  const container = scrollableRef.current;
  if (chatMessageStreamEnd.current) {
      chatMessageStreamEnd.current.scrollIntoView({ behavior: 'smooth' });
  } else if (container) {
    container.scrollTo({
      top: container.scrollHeight,
      behavior: 'smooth'
    })
  }
};


  type QuestionType = string | { action: string, dropdownChoices: string };

  const makeApiRequestWithCosmosDB = async (question: QuestionType, convId: string, ptr: number) => {
    setShowLoadingMessage(true);
    setIsLoading(true);

    const getQuestionValue = (question: any): string => {
      if (typeof question === 'object' && question !== null && 'dropdownChoices' in question) {
        return question;
      }
      return question;
    };

    const processedQuestion = getQuestionValue(question);

    setSignInMessage(true);
    setOnLoad(false);
    ScrollToBottom();
    setActiveQuestion(processedQuestion);
    localStorage.setItem("question", processedQuestion);
    const abortController = new AbortController();
    abortFuncs.current.unshift(abortController);

    const isDropdownQuestion = typeof question === 'object' && question !== null && 'dropdownChoices' in question;

    const userMessage: BotResponse = {
      id: uuid(),
      role: 'user',
      content: processedQuestion,
      date: new Date().toISOString(),
      feedback: undefined,
      type: 'message',
      timestamp: '',
      channelId: '',
      from: {
        id: '',
        name: ''
      },
      conversation: {
        id: '',
        title: '',
        messages: [],
        date: '',
      },
      text: '',
      inputHint: '',
      context: '',
      messageType: 'text',
      card: undefined,
      token: directLineToken,
      streamUrl: ''
    };


    if (!isDropdownQuestion) {
      if (ptr === 1) {
        messages.push(userMessage);
      }
      const newMessages = [...messages];

      const transformedMessages = newMessages.map((m) => {
        return m;
      });

      setMessages(transformedMessages);

    }

    try {
      if (appStateContext?.state.currentChat?.id) {
        sessionStorage.setItem("DBconversationId", appStateContext.state.currentChat.id);

        if (appStateContext.state.currentChat.messages[0].conversation["id"]) {
          // setConversationId(appStateContext.state.currentChat.messages[0].conversation["id"]);
          setDirectLineToken(appStateContext.state.currentChat.token);
          // reConnect(appStateContext.state.currentChat.messages[0].conversation["id"], appStateContext.state.currentChat.token);
        }
      }

      if (ptr === 1) {
        if (!appStateContext?.state.currentChat?.id) {
          SendMessage(convId, processedQuestion);
        } else {
          const conversId = appStateContext?.state.currentChat?.id === undefined || appStateContext?.state.currentChat === undefined ? convId : appStateContext?.state.currentChat?.id;
          SendMessage(conversId, processedQuestion);
        }

      }

      const jsonString = JSON.stringify(messages);
      localStorage.setItem("messages", jsonString);

      if (!isSubscribed) {
        setSubscription(true);
      }

      setProcessMessages(messageStatus.Processing);
    } catch (e) {
      if (!(e instanceof SyntaxError)) {
        console.error(e);
        throw e;
      } else {
        console.log("Incomplete message. Continuing...");
      }
    }
  };

  const SendMessage = (convId: string, message: string) => {
    let userMessage: UserMessage = {
      user_message: message,
      timestamp: getCurrentTimestamp()
    };
    

    const conv_id = conversationId || convId
    const url = `${config.env.API_URL}/${conv_id}/messages`;

    setFetchInputs({
      input: url,
      init: {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'X-Client-Source': getClientSource()
        },
        body: JSON.stringify(userMessage),
      }
    });
  }

  const consumeTheResponse = async (response: Response) => {
    if (!response.body) {
      throw new Error('ReadableStream not supported or no data!');
    }
  
    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';

    const sanitizeLatex = (text: string): string => {
      text = text.replace(/\$\$([\s\S]+?)\$\$/g, (match) => match);

      text = text.replace(/\\\[((?:.|\n)*?)\\\]/g, (match) => match);

      text = text.replace(/\\\(((?:.|\n)*?)\\\)/g, (match) => match);

      return text;
    };

    const tryExtractJson = (input: string): [any[], string] => {
      const results: any[] = [];
      let remaining = input;
  
      while (true) {
        const start = remaining.indexOf('{');
        if (start === -1) break;

        let inString = false;
        let escape = false;
        let braceCount = 0;
        let end = -1;

        for (let i = start; i < remaining.length; i++) {
          const char = remaining[i];

          if (escape) {
            escape = false;
          } else if (char === '\\') {
            escape = true;
          } else if (char === '"') {
            inString = !inString;
          } else if (!inString) {
            if (char === '{') braceCount++;
            else if (char === '}') braceCount--;
          }

          if (braceCount === 0 && !inString) {
            end = i;
            break;
          }
        }

        if (end === -1) break;

        const candidate = remaining.slice(start, end + 1);

        try {
          const parsed = JSON.parse(candidate);
          results.push(parsed);
          remaining = remaining.slice(end + 1);
        } catch {
          break;
        }
      }

      return [results, remaining];
    };

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      const [parsedObjects, remaining] = tryExtractJson(buffer);
      buffer = remaining;

      for (const parsed of parsedObjects) {
        if (parsed.message) {
          const sanitized = sanitizeLatex(parsed.message);
          processResponse(sanitized, parsed.conversation_id, parsed.msg_id);
          updateConversationIdInLocal(parsed.conversation_id);
        }

        if (parsed.adaptive_card) {
          if (Object.keys(parsed.adaptive_card).length > 0) {
            renderAdaptiveCard(parsed.adaptive_card, parsed.conversation_id, parsed.msg_id);
          } else {
            processResponse(parsed.message, parsed.conversation_id, parsed.msg_id);
          }
        }
      }
    }
  };
  

  const updateConversationIdInLocal = (conversation_id: string) => {
    setConversationId(conversation_id);
    localStorage.setItem("conversation_id", conversation_id);
  }

  // UseEffect to run when the messages state changes
  useEffect(() => {
    const dataSource = getStorageDataSource();
    const mappedAgent = mapDataSourceToAgent(dataSource);
    setSelectedAgent(mappedAgent);
    console.log('Agent changed : ' + mappedAgent)
    
    const historicalConversationId = localStorage.getItem("historylistConId");

    if (historicalConversationId)
      updateConversationIdInLocal(historicalConversationId);

    ScrollToBottom();
  }, [messages]); // Dependency array ensures this runs only when `messages` change

  const processResponse = (message: string, convid: string, messageId: string, category?: string) => {
    try{
      setIsLoading(true);
      setShowLoadingMessage(true);
      setProcessMessages(messageStatus.Processing);


      if (!message) return;

  let toolMessage = {} as BotResponse;
      let citation: any = null;

      if (isJson(message)) {
        let ci = JSON.parse(message);

        if (Array.isArray(ci)) {
          citation = parseCitations(ci);
        }
        else {
          citation = parseCitations([ci]);
        }
          
        toolMessage = {
          id: messageId,
          role: TOOL,
          content: citation,
          date: new Date().toISOString(),
          feedback: undefined,
          type: 'message',
          timestamp: '',
          channelId: '',
          from: {
            id: '',
            name: ''
          },
          conversation: {
            id: '',
            title: '',
            messages: [],
            date: ''
          },
          text: '',
          inputHint: '',
          context: '',
          messageType: 'tool',
          card: undefined,
          token: directLineToken,
          streamUrl: '',
          MessageCategory: category
        };
      }

      let response: BotResponse = {
        role: "",
        id: messageId,
        text: message,
        context: citation,
        messageType: "text",
        card: undefined,
        feedback: undefined,
        type: 'message',
        timestamp: '',
        date: '',
        channelId: '',
        from: {
          id: '',
          name: ''
        },
        conversation: {
          id: '',
          title: '',
          messages: [],
          date: ''
        },
        inputHint: '',
        content: '',
        token: '',
        streamUrl: '',
        MessageCategory: category

      };

      if (toolMessage.content) {
        response.role = "tool";
      } else {
        response.role = "assistant";
      }
      response.id = messageId;
      response.text = message;
      response.context = citation;
      response.messageType = "text";

      let q: string = localStorage.getItem("question") ?? '';
      let id: string = uuid();

      try {
        if (messages.length > 0) {
          let msg = [...messages].reverse().find((item) => item.role === 'user');
          if (msg) {
            id = msg.id;
          }
        }
      } catch (e) { }

      const userMessage: BotResponse = {
        id: id,
        role: "user",
        content: q,
        date: new Date().toISOString(),
        feedback: undefined,
        type: 'message',
        timestamp: '',
        channelId: '',
        text: '',
        inputHint: '',
        context: '',
        from: {
          id: userId,
          name: ''
        },
        conversation: {
          id: convid,
          title: '',
          messages: [],
          date: '',
        },
        messageType: 'text',
        card: undefined,
        token: '',
        streamUrl: ''
      };

      processResultMessage(response, userMessage, toolMessage, '');
      ScrollToBottom();
    }
    catch (e) {
      console.error("error while processing response. Error message: ", e)
    }
      finally{
      setProcessMessages(messageStatus.Done);
      setIsLoading(false);
      setShowLoadingMessage(false);
    }
  }
    

  const processResultMessage = (resultMessage: BotResponse, userMessage: BotResponse, toolMessage: BotResponse, conversationId?: string) => {
    if (resultMessage.role === ASSISTANT) {
      assistantContent += resultMessage.text
      assistantMessage = resultMessage
      assistantMessage.content = resultMessage.text
      assistantMessage.id = resultMessage.id
    }

    if (toolMessage.content) {
      messages.push(toolMessage);

      setMessages((prevMessages) => {
        const updatedMessages = [...prevMessages, toolMessage];
        console.log('Updated tool Messages:');
        return updatedMessages;
      });
      ScrollToBottom();
    }

    if (messages[messages.length - 1]?.id === assistantMessage.id) {
      messages[messages.length - 1].content = assistantMessage.content;
    }
    else {

      const messageExists = messages.some(message => message.id === assistantMessage.id);
      //const messageExists = messages.some(msg => JSON.stringify(msg) === JSON.stringify(assistantMessage));

      if (!messageExists) {
        console.log('push message...');
        if (assistantMessage)
          messages.push(assistantMessage);
      } else {
        console.log('Message with this ID already exists. Not pushing again.');
      }
    }

    setMessages(messages);
    ScrollToBottom();
    setProcessMessages(messageStatus.Done)
  }

  const GetDirectLineToken = async (show: boolean) => {
    if (show) {
      showMainPage()
    }
  }

  const getUserInfoListForTeams = async () => {
    try {
      const token = await getTeamsAuthToken();
      const claims = decodeToken(token);
      if (!claims) {
        throw new Error("Invalid token.");
      }
      trackAuthEvent("teams_token_acquired", {
        auth_path: "teams",
        token_iss: claims.iss ?? "",
        token_aud: claims.aud ?? "",
        token_oid: claims.oid ?? "",
        token_upn: claims.preferred_username ?? "",
        token_exp: claims.exp ?? "",
      });
      const userInfoList = createUserInfoList(token, claims);
      updateUserInfo(userInfoList, claims);
      setAuthenticated(true);
    } catch (error: any) {
      console.error("Error acquiring token or fetching user info for Teams:", error);
      trackAuthException(error, {
        auth_path: "teams",
        stage: "getUserInfoListForTeams",
        error_code: error?.errorCode ?? "",
        error_message: error?.message ?? "",
      });
      setShowAuthMessage(true);
    }
  };

  useEffect(() => {
    const storedExpiry = sessionStorage.getItem('akira_token_expiry')
    if (storedExpiry) {
      // Testing expiry for 2 mins
        // const testExpiry = new Date().getTime() + 2 * 60 * 1000
        // setTokenExpiry(testExpiry)
      setTokenExpiry(parseInt(storedExpiry))
      console.log('📦 [IframeAuth] Token expiry loaded from storage:', new Date(parseInt(storedExpiry)).toISOString())
    }
  }, [])

  const getUserInfoListForMsal = async (instance: any) => {
    // Iframe path: token was stored in sessionStorage by index.tsx on first load
    try { if (window.self !== window.top) {
      const injectedToken = sessionStorage.getItem('akira_injected_token')
      console.log('[IframeAuth:bot] In iframe, checking for injected token...')
      console.log('[IframeAuth:bot] sessionStorage.getItem("akira_injected_token"):', injectedToken ? '✅ FOUND' : '❌ NOT FOUND')
      if (injectedToken) {
        console.log('[IframeAuth:bot] Using injected token from sessionStorage')
        const claims = decodeToken(injectedToken)
        if (claims) {
          const userInfoList = createUserInfoList(injectedToken, claims)
          updateUserInfo(userInfoList, claims)
          setAuthenticated(true)
          // Notify parent that iframe is authenticated and ready
          try {
            window.parent.postMessage({ type: 'AKIRA_READY', status: 'authenticated' }, '*')
          } catch (e) {
            console.warn('[IframeAuth] Failed to send AKIRA_READY signal:', e)
          }
        }
        return
      }
    } } catch { /* not in iframe */ }

    // CRITICAL: If in iframe but no token, fail gracefully instead of trying MSAL
    if (window.self !== window.top) {
      console.error('[IframeAuth:bot] ❌ iframe detected but no injected token found in sessionStorage. Cannot authenticate.')
      setShowAuthMessage(true)
      return
    }

    try {

      const scopes = [
        `${config.env.REACT_APP_CLIENT_ID}/access_as_user`
      ];

      const account = instance.getActiveAccount();
      if (!account) {
        throw new Error("No active account! Please log in.");
      }
      const msalResponse = await instance.acquireTokenSilent({
        scopes: scopes,
        account: account,
      });

      const token = msalResponse.accessToken;
      const claims = msalResponse.idTokenClaims;
      const newExpiry = msalResponse.expiresOn;
      trackAuthEvent("msal_token_acquired", {
        auth_path: "msal",
        account_username: account.username ?? "",
        account_oid: account.localAccountId ?? "",
        token_exp: newExpiry ? newExpiry.getTime() : "",
        scopes: scopes.join(" "),
      });
      const userInfoList = createUserInfoList(token, claims);
      setTokenExpiry(newExpiry.getTime());
      localStorage.setItem("tokenExpiry", newExpiry.getTime())
      localStorage.setItem("newExpiry", newExpiry)
      updateUserInfo(userInfoList, claims);
      setAuthenticated(true);
    } catch (error: any) {
      console.error("Error acquiring token or fetching user info for MSAL:", error);
      trackAuthException(error, {
        auth_path: "msal",
        stage: "getUserInfoListForMsal",
        error_code: error?.errorCode ?? "",
        error_message: error?.message ?? "",
        sub_error: error?.subError ?? "",
      });
      setShowAuthMessage(true);
    }
  };

  useEffect(() => {
    // Refresh token if it's about to expire within the next 5 minutes
    const checkTokenExpiry = async () => {
      const currentTime = new Date().getTime();
      const expiryBufferTime = 5 * 60 * 1000; // 5 minutes buffer

      if (tokenExpiry - currentTime < expiryBufferTime) {
        if(window.self !== window.top) {
          console.log('🔄 [IframeAuth] Token expiring soon, calling backend to refresh...');
          try {
            const response = await fetch('/api/refresh-token', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ accessToken: accessToken })
            });
            const data = await response.json();
            
            if (data.newToken) {
              setAccessToken(data.newToken);
              const newExpiry = data.expiresAt * 1000; // seconds to ms
              setTokenExpiry(newExpiry);
              sessionStorage.setItem('akira_token_expiry', newExpiry.toString());
              console.log('✅ [IframeAuth] Token refreshed, expires at:', new Date(newExpiry).toISOString());
            } else {
              console.error('[IframeAuth] No newToken in response:', data);
            }
          } catch (err) {
            console.error('[IframeAuth] Failed to refresh token:', err);
          }
          return;
        }
        console.log('Token is about to expire, refreshing...');
        trackAuthEvent("token_refresh_triggered", {
          auth_path: "msal",
          token_expiry: tokenExpiry,
          current_time: currentTime,
          ms_remaining: tokenExpiry - currentTime,
        });
        try {
          await getUserInfoListForMsal(instance); // Refresh the token before it expires
        } catch (error: any) {
          trackAuthException(error, {
            auth_path: "msal",
            stage: "token_refresh",
            error_code: error?.errorCode ?? "",
            error_message: error?.message ?? "",
          });
        }
      }
    };

    // Set an interval to check token expiration every minute
    const intervalId = setInterval(checkTokenExpiry, 60000); // Check every 60 seconds

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);

  }, [tokenExpiry,accessToken]); // Dependency array to re-run effect when `tokenExpiry` changes


  
  useEffect(() => {
      let timer: ReturnType<typeof setTimeout>;;

      if (isLoading || showLoadingMessage) {
        setLoadingText("Generating answer...");
        timer = setTimeout(() => {
          setLoadingText("Thank you for waiting, generating the response is taking longer than usual...");
        }, 60000); // 60 seconds
      }

      return () => clearTimeout(timer);
    }, [isLoading, showLoadingMessage]);


  const updateUserInfo = (userInfoList: UserInfo[], claims: any) => {
    const emailClaim = claims.preferred_username;
    const userClaim = userInfoList[0]?.user_id;
    const accessToken = userInfoList[0]?.access_token;
    console.log("email Claim: ", emailClaim);
    console.log("user Claim: ", userClaim);
    console.log("Access Token: ", accessToken);
    console.log('🔑 [NEW Badge] AccessToken SET:', accessToken ? 'EXISTS (length: ' + accessToken.length + ')' : 'MISSING/EMPTY');
    setUserId(userClaim);
    setEmail(emailClaim);
    setAccessToken(accessToken);
    setEmailInLocalStorage(emailClaim);
    setUserIdInLocalStorage(userClaim);
    setAccessTokenInLocalStorage(accessToken);
    const rolesClaim = getClaimValue(userInfoList[0]?.user_claims, "roles");

    const toArray = (value: string | string[] | null): string[] => {
      if (value === null) {
        return [];
      }
      return typeof value === 'string' ? [value] : value;
    };

    setRoles(toArray(rolesClaim));
  };

  const getClaimValue = (userClaims: any[], claimType: string): string | string[] | null => {
    const claim = userClaims?.find((claim: { type: string; value: string | string[] }) => claim.type === claimType);
    return claim ? claim.value : null;
  };

  const makeApiRequest = async (prompt: string, conversationId: any) => {
    setShowLoadingMessage(true);
    setIsLoading(true);

    let datasource = getStorageDataSource();

    if (datasource === '') {
      datasource = constants.agent.unstructured;

      if (prompt.trim() === "PGGA" || prompt.trim() === constants.mappedAgent.pgga) {
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.pgga);
        datasource = constants.agent.pggaLessonsLearned;
      }
      else if (prompt.trim() === "PGTR Engineering" || prompt.trim() === constants.mappedAgent.pgtrEngineering) {
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.pgtrEngineering);
        datasource = constants.agent.pgtrEngineering;
      }
      else if (prompt.trim() === constants.mappedAgent.ccrp) {
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.ccrp);
        datasource = constants.agent.ccrp;
      }
      else if (prompt.trim() === constants.mappedAgent.pghv) {
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.pghv);
        datasource = constants.agent.pghv;
      }
      else if (prompt.trim() === constants.mappedAgent.pghvDatabases) {
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.pghvDatabases);
        datasource = constants.agent.pghvDatabases;
      }
      else if (prompt.trim() === constants.mappedAgent.sapCoe) {
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.sapCoe);
        datasource = constants.agent.sapCoe;
      }
      else if (prompt.trim() === constants.mappedAgent.ror){
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.ror);
        datasource = constants.agent.ror;
      }
      else if (prompt.trim() === constants.mappedAgent.lcNuclear){
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.lcNuclear);
        datasource = constants.agent.lcNuclear;
      }
      else if(prompt.trim() === constants.mappedAgent.gpt5_gk){
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.gpt5_gk);
        datasource = constants.agent.gpt5_gk;
      }
      else if (prompt.trim() === constants.mappedAgent.scm) {
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.scm);
        datasource = constants.agent.vayu;
      }
      else if (prompt.trim() === constants.mappedAgent.finance) {
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.finance);
        datasource = constants.agent.vayu;
      }
      else if (prompt.trim() === constants.mappedAgent.pmcert) {
        setStructuredQuery(true);
        localStorage.setItem("title", constants.mappedAgent.pmcert);
        datasource = constants.agent.pmcert;
      }
      else if(prompt.trim() === constants.mappedAgent.zaragoza){
        setStructuredQuery(true);
        localStorage.setItem("dataSource", constants.agent.zaragoza);
        localStorage.setItem("title", constants.mappedAgent.zaragoza);
        datasource = constants.agent.zaragoza;
      }
      else if(prompt.trim() === constants.mappedAgent.hseincident){
        setStructuredQuery(true);
        localStorage.setItem("dataSource", constants.agent.hseincident);
        localStorage.setItem("title", constants.mappedAgent.hseincident);
        datasource = constants.agent.hseincident;
      }
      else if(prompt.trim() === constants.mappedAgent.digitalCoreCoe){
        setStructuredQuery(true);
        localStorage.setItem("dataSource", constants.agent.digitalCoreCoe);
        localStorage.setItem("title", constants.mappedAgent.digitalCoreCoe);
        datasource = constants.agent.digitalCoreCoe;
      }
      else if(prompt.trim() === constants.mappedAgent.grcm){
        setStructuredQuery(true);
        localStorage.setItem("dataSource", constants.agent.grcm);
        localStorage.setItem("title", constants.mappedAgent.grcm);
        datasource = constants.agent.grcm;
      }

      setStorageDataSource(datasource);

      if (datasource === constants.agent.unstructured) {
        makeApiRequestWithCosmosDB(prompt, 'new_conversation', 1);
        setSelectedAgent(constants.agent.unstructured);
      }
      else {
        handleCreateConversation(datasource);
        makeApiRequestWithCosmosDB(prompt, conversationId, 0);
      }
    }
    else {
      makeApiRequestWithCosmosDB(prompt, conversationId, 1);
    }

    console.log(prompt);
    setPageLoad(false);

  }

  const handleSelection = async (level: number, selectedOption: string, previousSelections: string[]) => {
    let nextAvailableOptions: any
    const schemaLevel: number = level;

    if (previousSelections.length === 0) {
      // First level selection
      nextAvailableOptions ={}
    } else {
      // Subsequent selections
     const mode = previousSelections.includes(constants.function.ccrpLastWeek)
        ? agentMode.NEW_CCRPS_FROM_LAST_WEEK
                : previousSelections.includes(constants.function.progressBreakdown)
                  ? agentMode.PROGRESS_BREAKDOWN
                  : agentMode.UNDEFINED;;

      const options = mode === agentMode.NEW_CCRPS_FROM_LAST_WEEK
        ? availableOptionsFixForCCRP()
                  : mode === agentMode.PROGRESS_BREAKDOWN
                    ?  availableOptions?.progress_breakdown?.value || {}
                    : {}
      
      if (mode === agentMode.NEW_CCRPS_FROM_LAST_WEEK) {
        nextAvailableOptions = { ...options[1] };

        if (previousSelections.length > 1) {

          for (let index = 1; index < previousSelections.length; index++) {
            const elements = Object.entries(nextAvailableOptions);
            const element = elements.find((value) => value[0] === previousSelections[index]);

            if (index > 2)
              nextAvailableOptions = element?.[1];
            else {
              const subOpt = element?.[1] as any;
              nextAvailableOptions = subOpt[1] !== undefined ? subOpt[1] : subOpt;
            }
          }

          nextAvailableOptions = nextAvailableOptions[selectedOption];
        }
        else {
          const selectedOpt = nextAvailableOptions[selectedOption];
          nextAvailableOptions = selectedOpt[1];
        }
      }
      else {
        while (true) {
          nextAvailableOptions = { ...options };
          if (previousSelections.length > 1) {
            for (let index = 1; index < previousSelections.length; index++) {
              const elements = Object.entries(nextAvailableOptions);
              const element = elements.find((value) => value[0] === previousSelections[index]);

              nextAvailableOptions = element?.[1];
            }
          }

          nextAvailableOptions = nextAvailableOptions[selectedOption]

          if (typeof nextAvailableOptions === 'string') {
            selectedOption = nextAvailableOptions;
            nextAvailableOptions = undefined;
            break;
          }

          if (nextAvailableOptions === undefined)
            break;

          previousSelections = [...previousSelections, selectedOption];
          selectedOption = Object.keys(nextAvailableOptions)[1];
          level++;
        }
      }
    }

    if (nextAvailableOptions !== undefined && Object.keys(nextAvailableOptions).length > 0) {
      ButtonClick(selectedOption, nextAvailableOptions, level++, [...previousSelections, selectedOption], schemaLevel)
    } else {
      // Final selection, make API request
      if (previousSelections.length === 0)
        makeApiRequest(selectedOption, conversationId);
      else
        await makeApiRequestPayload(conversationId, [...previousSelections, selectedOption]);
    }
  }

  const fetchAutocompleteOptions = async (phrase: string, token: string, signal: AbortSignal): Promise<string[]> => {
    const response = await fetch(`${config.env.REACT_APP_WEB_REDIRECT_URI}/api/search_options?search_phrase=${encodeURIComponent(phrase)}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',

      },
      signal
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch options: ${response.statusText}`);
    }

    const data = await response.json();
    return data.completions || [];
  };

  const fetchAutocompleteSapProjectInsightsOptions = async (phrase: string, token: string, signal: AbortSignal): Promise<string[]> => {
    const response = await fetch(`${config.env.API_URL}/sap_coe/projects?search_phrase=${encodeURIComponent(phrase)}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',

      },
      signal
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch options: ${response.statusText}`);
    }

    const data = await response.json();
    return data.completions || [];
  };


  const ButtonClick = async (
    data: any,
    availableParameters: KeyValuePair = {},
    level = 0,
    previousSelections: string[] = [],
    schemaLevel: number = 0
  ) => {

    if (data === constants.function.ccrpLastWeek)
      insightsSchema.current = availableOptions?.new_ccrps_from_last_week?.schema || [];
    if (data === constants.function.changeDataSource) 
      insightsSchema.current = availableOptions?.change_data_source?.schema || [];
    if (data === constants.function.ccrpAiAnalyzer) {
      const ccrpAiAnalyzerLink = (availableOptions?.ccrp_ai_analyzer?.parameters as { aiAnalyzer_Link?: string })?.aiAnalyzer_Link;
      if (ccrpAiAnalyzerLink) {
        window.open(ccrpAiAnalyzerLink, '_blank');
      }
      return;
    }
    if( data === constants.function.coeKnowledgeHub) {
      const powerbiLink = (availableOptions?.sap_knowledge_hub?.parameters as { powerbi_link?: string })?.powerbi_link;
      if (powerbiLink) {
        window.open(powerbiLink, '_blank');
      }
      return;
    }

    if (data === constants.function.progressBreakdown)
      insightsSchema.current = availableOptions?.progress_breakdown?.schema || [];
    if (data === constants.function.issueOverview) {
      setAutocompleteValue('');
      messages.push({
        role: 'assistant',
        card: undefined,
        feedback: undefined,
        type: '',
        id: '',
        timestamp: '',
        date: '',
        channelId: '',
        from: {
          id: '',
          name: ''
        },
        conversation: {
          id: '',
          title: '',
          messages: [],
          date: ''
        },
        text: '',
        inputHint: '',
        context: '',
        content: 'Please select CCRP Number:',
        messageType: 'autocomplete',
        token: '',
        streamUrl: ''
      })

      setMessages([...messages]);
      ScrollToBottom();
    } else if (data === constants.function.sapProjectInsights){
      setAutocompleteValue('');
      messages.push({
        role: 'assistant',
        card: undefined,
        feedback: undefined,
        type: '',
        id: '',
        timestamp: '',
        date: '',
        channelId: '',
        from: {
          id: '',
          name: ''
        },
        conversation: {
          id: '',
          title: '',
          messages: [],
          date: ''
        },
        text: '',
        inputHint: '',
        context: '',
        content: 'Please select Project:',
        messageType: 'autocompleteSapProjectInsights',
        token: '',
        streamUrl: ''
      })

      setMessages([...messages]);
      ScrollToBottom();
    } else {

      let options: {} =
         data === constants.function.ccrpLastWeek
              ? availableOptions?.new_ccrps_from_last_week?.value || {}
                : data === constants.function.progressBreakdown
                  ? availableOptions?.progress_breakdown?.value || {}
                  : data === constants.function.changeDataSource
                    ? (availableOptions?.change_data_source?.value as Record<string, Record<string,string>>)?.["Data Source"] || {}
                  : availableParameters


      let choices: ChoicesChoiceSet[] = Array.isArray(options)
        ? options.map(x => {
          return Array.isArray(x)
            ? { title: x[0], value: JSON.stringify(x) } //Project Insights after the country is choosen. This is the only option to send id nad name together
            : { title: x, value: x }
        })
        : Object.keys(options).map(x => {
          return { title: x, value: x }
        })

      if (data === constants.function.ccrpLastWeek) {
        const issues = Object.entries(options)[0] as [string, string[]];
        choices = issues[1].map(x => { return { title: x as string, value: x as string }; });
      }

      if(data === constants.function.progressBreakdown){
        choices = (Object.values(options)[0] as string[]).map(value => ({ title: value, value }));
      }

      if(data === constants.function.changeDataSource){
        choices = Object.entries(options as Record<string, string>).map(([title, value]) => ({ title, value }));
      }

      const adaptiveCard = {
        type: 'AdaptiveCard',
        body: [
          {
            id: uuid(),
            type: 'TextBlock',
            text: getDropdownLabel(previousSelections, insightsSchema.current, level, schemaLevel),
            weight: 'bolder',
            size: 'medium'
          },
          {
            type: 'Input.ChoiceSet',
            id: `choiceSet${level}`,
            style: 'compact',
            choices: choices,
            isMultiSelect: false,
            value: data,
            isRequired: true,
            errorMessage: "Please select an option",
            name: `choiceSet_${level}_${choices[0]?.value || 'default'}`
          }
        ],
        actions: [
          {
            type: 'Action.Submit',
            title: 'Submit',
            data: { level: level, previousSelections: previousSelections, selectedOption: data }
          }
        ],
        $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
        version: '1.5'
      }

      if (availableOptions != null && Object.keys(availableOptions).length !== 0)
        renderAdaptiveCard(adaptiveCard, conversationId)
      else {
        const assistantMessage: BotResponse = {
          id: uuid(),
          role: ERROR,
          content: "INFO: This function is unavailable due to it being invoked for the historical conversation. To use this button please start a new conversation with the Agent.",
          date: new Date().toISOString(),
          feedback: undefined,
          type: "message",
          timestamp: '',
          channelId: '',
          from: {
            id: '',
            name: ''
          },
          conversation: {
            id: '',
            title: '',
            messages: [],
            date: '',
          },
          text: '',
          inputHint: '',
          context: '',
          messageType: 'error',
          card: undefined,
          token: directLineToken,
          streamUrl: ''
        };
        messages.push(assistantMessage);
      }
    }
  }

  const handleSubmit = async (data: any) => {

    if (data.function === constants.function.issueOverview || data.function === constants.function.ccrpLastWeek || data.function === constants.function.ccrpAiAnalyzer || data.function === constants.function.coeKnowledgeHub
      || data.function === constants.function.progressBreakdown || data.function === constants.function.sapProjectInsights || data.function === constants.function.changeDataSource) {

      ButtonClick(data.function, availableOptions)
    }
    else if (data.choiceSet0) {
      const selectedOption = data.choiceSet0
      console.log('selectedOption :>> ', selectedOption);
      await handleSelection(1, selectedOption, [data.selectedOption])
    } else if (data.choiceSet1) {
      const selectedOption = data.choiceSet1
      await handleSelection(2, selectedOption, data.previousSelections)
    } else if (data.choiceSet2) {
      const selectedOption = data.choiceSet2
      await handleSelection(3, selectedOption, data.previousSelections)
    } else if (data.choiceSet3) {
      const selectedOption = data.choiceSet3
      await handleSelection(4, selectedOption, data.previousSelections)
    } else if (data.choiceSet4) {
      const selectedOption = data.choiceSet4
      await handleSelection(5, selectedOption, data.previousSelections)
    } else if (data.choiceSet5) {
      const selectedOption = data.choiceSet5
      await handleSelection(6, selectedOption, data.previousSelections)
    } else if (data.choiceSet6) {
      const selectedOption = data.choiceSet6
      await handleSelection(7, selectedOption, data.previousSelections)
    } else {
      setStructuredQuery(true)

      if (data.function)
        await makeApiRequestPayload(conversationId, [data.function]);
      else
        makeApiRequestWithCosmosDB(data, conversationId, 1)
      setPageLoad(false)
      ScrollToBottom()
    }

  }

  // Function to handle creating a new conversation
  const handleCreateConversation = async (agent: string): Promise<any> => {
    try {
      setIsLoading(true);
      setShowLoadingMessage(true);
      const authHeader = accessToken;
      const clientSource = getClientSource();
      const newConversation = await createNewConversationNew(agent, authHeader, clientSource);
      console.log(newConversation);
 
      if (newConversation) {
        if (newConversation.status === 401) {
          updateNotAuthMsg(agent);
        } else {
          console.log('New conversation created with ID:', newConversation.conversation_id);
          setConversationId(newConversation.conversation_id);
          localStorage.setItem("conversation_id", newConversation.conversation_id);
 
          if (newConversation.adaptive_card) {
            renderAdaptiveCard(JSON.parse(newConversation.adaptive_card), newConversation.conversation_id, undefined, 'greeting');
          }
          if (newConversation.message) {
            processResponse(newConversation.message, newConversation.conversation_id ?? '', '', 'greeting')
          }
 
          if (newConversation.available_parameters) {
            setAvailableOptions(newConversation.available_parameters || null);
          }
 
          return true;
        }
      }
    } catch (err) {
      console.error(err);
      if (err instanceof Error) {
        const statusMatch = err.message.match(/responseStatus:\s*(\d+)/);
        const responseStatus = statusMatch ? parseInt(statusMatch[1]) : undefined;
        
        if (responseStatus === 403) {
          updateNotAuthMsg(agent);
        }
      }
      return false;
    }
    finally {
      setIsLoading(false);
      setShowLoadingMessage(false);
    }
  };

  const makeApiRequestPayload = async (convId: string, selections: string[]) => {
    setShowLoadingMessage(true);
    setIsLoading(true);
    const url = `${config.env.API_URL}/${convId}/post_function`
    const timestamp = getCurrentTimestamp()
    const func = selections[0]
    let parameters: PortfolioInsightsPayload | {} = {}


    if (func === constants.function.ccrpLastWeek)
      parameters = {
        "Issue Type": selections.hasOwnProperty(1) && selections[1] !== undefined ? selections[1] : '',
        "BU Code": selections.hasOwnProperty(2) && selections[2] !== undefined ? selections[2] : '',
        "PG Name": selections.hasOwnProperty(3) && selections[3] !== undefined ? selections[3] : '',
        "Business Activity": selections.hasOwnProperty(4) && selections[4] !== undefined ? selections[4] : '',
        Region: selections.hasOwnProperty(5) && selections[5] !== undefined ? selections[5] : '',
        Country: selections.hasOwnProperty(6) && selections[6] !== undefined ? selections[6] : '',
        City: selections.hasOwnProperty(7) && selections[7] !== undefined ? selections[7] : '',
      };

    if (func === constants.function.progressBreakdown)
      parameters = {
        "Module": selections.hasOwnProperty(1) && selections[1] !== undefined ? selections[1] : '',
      };

    if (func === constants.function.issueOverview) {
      parameters = {
        "CCRP No": selections[1] ?? ''
      };
    }

    if (func === constants.function.sapProjectInsights) {
      parameters = {
        "Project": selections[1] ?? ''
      };
    }

    if (func === constants.function.changeDataSource) {
      parameters = {
        "Data Source": selections[1] ?? ''
      };
    }

    const payload: ApiPostFunctionRequest = {
      function: func,
      parameters,
      timestamp
    };

    let label = `${func}`;
    if (func === constants.function.changeDataSource) {
      // selections[1] holds the technical value; look up its display title for the confirmation message
      const dataSourceMap = (availableOptions?.change_data_source?.value as Record<string, Record<string, string>>)?.["Data Source"] || {};
      const selectedTitle = Object.entries(dataSourceMap).find(([, value]) => value === selections[1])?.[0] ?? selections[1] ?? '';
      label = `Selected Data source : ${selectedTitle}`;
    }
    else if (selections.length > 1) {
      label += ` : ${selections.slice(1).join(' > ')}.`;
    } else {
      label += `.`;
    }

    const userMessage: BotResponse = {
      id: uuid(),
      role: 'user',
      content: label,
      date: new Date().toISOString(),
      feedback: undefined,
      type: 'message',
      timestamp: '',
      channelId: '',
      from: {
        id: '',
        name: ''
      },
      conversation: {
        id: '',
        title: '',
        messages: [],
        date: '',
      },
      text: '',
      inputHint: '',
      context: '',
      messageType: 'text',
      card: undefined,
      token: directLineToken,
      streamUrl: ''
    };

    messages.push(userMessage);

    setFetchInputs({
      input: url,
      init: {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    });
  }

  const handleSwitchAgentTiles = async (prompt: any) => {
    setIsLoading(true);
    setShowLoadingMessage(true);
    await newChat();
    setSelectedAgent('');
    setIsLoading(false);
    setShowLoadingMessage(false);
    handleCardClick(prompt);
  }

  const handleCardClick = async(prompt: any) => {
    const isScmTile =
    prompt?.title === constants.mappedAgent.scm ||
    prompt?.content === constants.mappedAgent.scm ||
    prompt?.title === "SCM" ||
    prompt?.content === "SCM";

  const isFinanceTile =
    prompt?.title === constants.mappedAgent.finance ||
    prompt?.title === "Finance" ||
    prompt?.content === "Finance";

    if (isScmTile || isFinanceTile) {
    setIsLoading(false);
    setShowLoadingMessage(false);
    window.open(config.env.REACT_TEAMS_VAYU_APP_URL, "_blank");
    return;
  }
    setIsLoading(true);
    setShowLoadingMessage(true);
    setStructuredQuery(true);
    console.log(prompt);
    setSelectedAgent(prompt.content);

    const assistantRedirectMap: Record<string, string> = {
      'HVDC Academy': config.env.HVDC_ACADEMY_APP_URL || '',
      'Project Navigator':config.env.PROJECT_NAVIGATOR_URL || '',
      'Taiju': config.env.TAIJU_APP_URL || ''
    };

    const assistantTitle = prompt?.title;

    if (assistantTitle && assistantRedirectMap[assistantTitle]) {
      window.location.assign(assistantRedirectMap[assistantTitle]);
    }

    const datasource = promptMappings[prompt.content];

    if (!datasource) return;

    setStorageDataSource(datasource);

      if (datasource === "hv_project_tracker") {
      navigate('/agent/hvproject');
      return;
    }
      if (datasource === "structured") {
      navigate('/agent/projectinsight');
    } 
    else {
      if (!conversationIdFromUrl) {
        console.log('📝 Creating new conversation for datasource:', datasource);
        await handleCreateConversation(datasource);
      } else {
        console.log('📂 Loading from history, skipping new conversation');
      }
      localStorage.setItem("title", prompt.content);
      makeApiRequestWithCosmosDB(prompt.content, conversationId, 0);
      setPageLoad(false);
      setIsLoading(false);
      setShowLoadingMessage(false);
      setIsDataInitialized(true);
      ScrollToBottom();
    }
  };

  const setStorageDataSource = (dataSource?: string) => {
    if (!dataSource) {
      return;
    }

    if (isTeams) {
      localStorage.setItem("dataSource", dataSource);
    } else {
      sessionStorage.setItem("dataSource", dataSource);
    }
  }

  const getStorageDataSource = () : string => {
    return isTeams ? 
      localStorage.getItem("dataSource") ?? "" : 
      sessionStorage.getItem("dataSource") ?? "";
  }

  const handleAgentLabelClick = (): void => {
    if (agentRedirect && config.env.NEW_ARCHITECT_URL) {
      // console.log('✅ Full page redirect to:', config.env.NEW_ARCHITECT_URL);
      window.location.href = config.env.NEW_ARCHITECT_URL;
      return;
    }

    setIsLoading(true);
    setShowLoadingMessage(true);

    newChat();
    setSelectedAgent('');

    setIsLoading(false);
    setShowLoadingMessage(false);
    navigate('/');
  }

  const availableOptionsFixForCCRP = (): any => {
    const resUnit = Object.entries(availableOptions?.new_ccrps_from_last_week?.value as { [s: string]: string }[])[1] as any[];
    let result = Object.entries(availableOptions?.new_ccrps_from_last_week?.value as { [s: string]: string }[])[0] as any[];
    const ress = {
      [result[1][0]]: resUnit,
      [result[1][1]]: resUnit,
    };
    result[1] = ress;

    return result;
  }

  const handleACSubmitSapProjectInsights = async (selected: string) => {
    if (!selected) return;
    const selections = [constants.function.sapProjectInsights, selected];
    await makeApiRequestPayload(conversationId, selections);
  };

  const onACSapProjectInsightsInputChange = async (event: React.SyntheticEvent, value: string, reason: string) => {
    setAutocompleteValue(value);

    if (value.length < 2) {
      setAutocompleteOptions([]);
      return;
    }

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      const options = await fetchAutocompleteSapProjectInsightsOptions(value, accessToken, controller.signal);
      setAutocompleteOptions(options);
    } catch (error: any) {
      if (error.name === 'AbortError') {
        console.log('Previous autocomplete request aborted');
      } else {
        console.error('Autocomplete fetch error:', error);
      }
    }
  };

  const handleACSubmit = async (selected: string) => {
    if (!selected) return;
    const selections = [constants.function.issueOverview, selected];
    await makeApiRequestPayload(conversationId, selections);
  };

  const onACInputChange = async (event: React.SyntheticEvent, value: string, reason: string) => {
    setAutocompleteValue(value);

    if (value.length < 2) {
      setAutocompleteOptions([]);
      return;
    }

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      const options = await fetchAutocompleteOptions(value, accessToken, controller.signal);
      setAutocompleteOptions(options);
    } catch (error: any) {
      if (error.name === 'AbortError') {
        console.log('Previous autocomplete request aborted');
      } else {
        console.error('Autocomplete fetch error:', error);
      }
    }
  };

  const handleTileArrowButtonClick = async (tile: any) => {
    handleCardClick(tile);
  };

  const handleCloseCitationPanel = () => {
    setIsCitationPanelOpen(false);
    setActiveCitation(undefined);
  }

  const showCitationPanel = !!(messages && messages.length > 0 && isCitationPanelOpen && activeCitation);
  const showHistoryPanel = !!(appStateContext?.state.isChatHistoryOpen && appStateContext?.state.isCosmosDBAvailable?.status !== CosmosDBStatus.NotConfigured);

  if (!isDataInitialized)
    return <div>Loading...</div>;

 return (
<div className={styles.container} role="main">
      {false ? (
        <Stack className={styles.chatEmptyState}>
          <ShieldLockRegular className={styles.chatIcon} style={{ color: 'darkorange', height: "200px", width: "200px" }} />
          <h1 className={styles.chatEmptyStateTitle}>Authentication Not Configured</h1>
          <h2 className={styles.chatEmptyStateSubtitle}>
            This app does not have authentication configured. Please add an identity provider by finding your app in the <a href="https://portal.azure.com/" target="_blank">Azure Portal</a>
            and following <a href="https://learn.microsoft.com/en-us/azure/app-service/scenario-secure-app-authentication-app-service#3-configure-authentication-and-authorization" target="_blank">these instructions</a>.
          </h2>
          <h2 className={styles.chatEmptyStateSubtitle} style={{ fontSize: "20px" }}><strong>Authentication configuration takes a few minutes to apply. </strong></h2>
          <h2 className={styles.chatEmptyStateSubtitle} style={{ fontSize: "20px" }}><strong>If you deployed in the last 10 minutes, please wait and reload the page after 10 minutes.</strong></h2>
        </Stack>
      ) : (
        <Stack horizontal className={styles.chatRoot} style={{margin: "0px 20px 20px"}}>
          <PanelGroup orientation="horizontal" style={{ width: '100%', height: '100%' }}>
            <Panel defaultSize="100%" minSize="40%" className={styles.chatContainer} style={{height:`${agentRedirect ? "100vh" : "calc(100vh - 100px)"}`}}>
              {isHistoryLoading?<div style={{margin:'auto',fontSize:'x-large',fontWeight:'600'}}>Loading Chat history...</div>:<>
                {(!messages || messages.length < 1) && !selectedAgent ? (
                    <Stack className={styles.chatEmptyState}>
                      <img
                        src={AkiraPictogram}
                        className={styles.chatIcon}
                        aria-hidden="true"
                      />
                      <h1 className={styles.chatEmptyStateTitle}>{ui?.chat_title}</h1>
                      <h2 className={styles.chatEmptyStateSubtitle} style={{ textAlign: 'justify' }} />
                      <div style={{ width: "calc(100% - 100px)", padding: "12px 30px 24px", color: "#616161", maxWidth: "1028px" }}>
                        <div style={{ textAlign: 'justify' }}>
                          <div>Disclaimer</div>
                      <div>Akira is our AI solution to support Hitachi Energy employees with the latest GenAI technology. For accounting policies and reporting topics click on the Finance icon below.</div>
                      <div>Please do not enter into the chat any data involving personal data, health and financial.</div>
                        </div>
                      </div>
                      <div style={{ paddingLeft:"6vw",color: "#616161" }}>
                        <div className={`${styles.tiles_container} ${showAllTiles ? styles.tiles_container_expanded : styles.tiles_container_collapsed}`} style={{marginBottom:`${agentRedirect ? "30px" : ""}`}}>
                          {tilesData.map((tile, index) => (
                            <Tile key={index}
                              title={tile.title}
                              content={tile.content}
                              icon={tile.icon}
                              onClick={() => handleCardClick(tile)}
                              disabled={tile.shouldBeDisabled}
                              displayStatus={tile.content === 'PGHV Databases' ? 'none' : ''}
                              onArrowButtonClick={tile.content === 'HV Products and Services' ? () => handleTileArrowButtonClick(tilesData.find(t => t.content === 'PGHV Databases')) : undefined}
                              tilesData={tilesData}
                              isNew={tile.isNew}
                            />
                          ))}
                        </div>
                        {!showAllTiles && tilesData.filter(t => t.content !== 'PGHV Databases').length > 5 && (
                          <a
                            className={styles.loadMoreButton}
                            role="button"
                            tabIndex={0}
                            onClick={() => setShowAllTiles(true)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowAllTiles(true); }}
                          >
                            Load more...
                          </a>
                        )}
                        {
                          agentRedirect ? 
                          <div style={{textAlign:"center"}}>
                          Click <span onClick={() => window.location.assign(config.env.NEW_ARCHITECT_URL)} style={{textDecoration: "underline",cursor:"pointer",fontWeight:"bold"}}>here</span> to open the New Akira Portal.
                        </div> :null
                        }
                      </div>
                    </Stack>
                  ) : (
                    <div className={styles.chatMessageStream} style={{ marginBottom: isLoading ? "40px" : "5px" }} role="log">
                      {messages.map((answer, index) => (
                        <div>
                          {answer.role === "user" ? (
                            <div className={styles.chatMessageUser} tabIndex={0}>
                              {answer.messageType === 'card'
                                ? (<AdaptiveCardRenderer  card={answer.card} onSubmit={handleSubmit} isLoading={(showLoadingMessage || isLoading || fetchInputs !== undefined)} />)
                                : (<div className={styles.chatMessageUserMessage}>{answer.content}</div>)}
                            </div>
                          ) : (
                            answer.role === "assistant" ? <div>
                              {answer.type === 'adaptiveCard' && answer.content ?
                                (
                                  <div> <img className={styles.UserProfile} src={AkiraPictogram} alt="Avatar">
                                  </img>
                                    <div className={styles.chatMessageGpt}
                                      key={answer.id}
                                      id={`message-${answer.id}`}
                                    >
                                      <AdaptiveCardRenderer messages={messages} messageId={answer.id} card={answer.content} onSubmit={handleSubmit} isLoading={(showLoadingMessage || isLoading || fetchInputs !== undefined)} />
                                    </div></div>
                                )
                                : answer.messageType === 'autocomplete' ?
                                  (
                                    <div> <img className={styles.UserProfile} src={AkiraPictogram} alt="Avatar"></img>
                                      <div className={styles.chatMessageGpt}
                                        key={answer.id}
                                        id={`message-${answer.id}`}
                                      >

                                        <AutoCompleteCard
                                          label={answer.content}
                                          options={autocompleteOptions}
                                          value={autocompleteValue}
                                          onSubmit={handleACSubmit}
                                          noOptionsText='Please type at least two characters to start searching CCRP Number'
                                          onInputChange={onACInputChange}
                                        />
                                      </div></div>
                                  )
                                  : answer.messageType === 'autocompleteSapProjectInsights' ?
                                    (
                                      <div> <img className={styles.UserProfile} src={AkiraPictogram} alt="Avatar"></img>
                                        <div className={styles.chatMessageGpt}
                                          key={answer.id}
                                          id={`message-${answer.id}`}
                                        >
                                          <AutoCompleteCard
                                            label={answer.content}
                                            options={autocompleteOptions}
                                            value={autocompleteValue}
                                            onSubmit={handleACSubmitSapProjectInsights}
                                            noOptionsText="Please type at least two characters to start searching Project"
                                            onInputChange={onACSapProjectInsightsInputChange}
                                          />
                                        </div></div>
                                    )
                                  : answer.messageType === 'signin' ?
                                    (<div> <img className={styles.UserProfile} src={AkiraPictogram} alt="Avatar">
                                    </img><div className={styles.chatMessageGpt}>
                                        <div dangerouslySetInnerHTML={{ __html: answer.content }} />
                                      </div></div>
                                    ) :
                                    answer.type === 'message' ? (
                                      <div> <img className={styles.UserProfile} src={AkiraPictogram} alt="Avatar">
                                      </img>
                                        <div
                                          key={answer.id}
                                          id={`message-${answer.id}`}
                                          className={styles.chatMessageGpt}>
                                            <Answer answer={{ answer: answer.content, 
                                            citations: parseCitationFromMessage(messages[index + 1]), 
                                            message_id: answer.id, 
                                            feedback: answer.feedback, 
                                            order_id: answer.orderId, 
                                            MessageCategory: answer.MessageCategory }} 
                                            onCitationClicked={c => onShowCitation(c)} 
                                            messages={messages}
                                            selectedAgent={selectedAgent}

                                      /></div></div>) : (null)}

                              </div> : answer.role === ERROR ?
                                <div className={styles.botError}>
                                  <img className={styles.UserProfile} src={AkiraPictogram} alt="Avatar" />
                                  <div className={styles.chatMessageError}>
                                    <Stack horizontal className={styles.chatMessageErrorContent}>
                                      <ErrorCircleRegular className={styles.errorIcon} style={{ color: "rgba(182, 52, 67, 1)" }} />
                                      <span>Error</span>
                                    </Stack>
                                    <span className={styles.chatMessageErrorContent}>
                                      <ReactMarkdown children={answer.content} linkTarget="_blank" className={styles.errorText}/>
                                    </span>
                                  </div>
                                </div>
                                : null
                          )}
                        </div>
                      ))}
                      {(showLoadingMessage || isLoading) && (
                        <div><img className={styles.UserProfile} src={AkiraPictogram} alt="Avatar">
                        </img>
                          <div className={styles.chatMessageGpt}>
                            <Answer
                              answer={{
                                answer: "Generating answer...",
                                citations: [],
                                order_id: 0,
                                MessageCategory: undefined
                              }}
                              onCitationClicked={() => null}
                              messages={[]}
                              selectedAgent={selectedAgent}
                            />
                          </div>
                        </div>
                      )}
                      <div ref={chatMessageStreamEnd} />
                    </div>
                  )}
                  {
                    (agentRedirect && (selectedAgent==='' || selectedAgent === 'unstructured')) ? null:
                  <Stack horizontal className={styles.chatInput}>
                  <Stack tokens={{ childrenGap: 10 }}>
                      <div id="newChat" onMouseEnter={onHoverNewChat} onMouseLeave={onLeaveNewChat}>
                        <span id="tooltipchat" className={styles.tooltipNewChat}>
                          {onHoverChat ? ((isResetableAgent && selectedAgent.toLowerCase() === constants.agent.trafochat) ? "Clean chat session" : "Start a new chat") : ''}
                        </span>
                        <CommandBarButton
                          role="button"
                          styles={{
                            icon: { color: '#FFFFFF' },
                            iconDisabled: { color: "#BDBDBD !important" },
                            root: {
                              color: '#FFFFFF',
                              background: "radial-gradient(109.81% 107.82% at 100.1% 90.19%, #eb0023 33.63%, #eb0023 70.31%, #eb0023 100%)"
                            },
                            rootDisabled: { background: "#F0F0F0" }
                          }}
                          className={styles.newChatIcon}
                          iconProps={{ iconName: (isResetableAgent && selectedAgent.toLowerCase() === constants.agent.trafochat) ? 'Refresh' : 'Add' }}
                          onClick={() => resetChatOrNavigateMainPage(selectedAgent)}
                          disabled={disabledButton()}
                          aria-label={isResetableAgent ? 'clean chat session button' : 'start a new chat button'}
                        />
                      </div>

                    <Dialog
                      hidden={hideErrorDialog}
                      onDismiss={handleErrorDialogClose}
                      dialogContentProps={errorDialogContentProps}
                      modalProps={modalProps}
                    />
                  </Stack>
                  <QuestionInput
                    clearOnSend
                    placeholder={onLoad ? "Hello, I'm Akira, How can I help you today?" : "Type a new question..."}
                    disabled={isLoading || notAuthorized}
                    selectedAgent={selectedAgent || ""}
                    handleLabelClick={handleAgentLabelClick}
                    showLabel={Boolean(selectedAgent && selectedAgent != constants.agent.unstructured && selectedAgent !== 'Documents & Trainings' && selectedAgent !== 'HV Databases')}
                    isLabelReadOnly={selectedAgent.toLowerCase() === constants.agent.trafochat}
                    onSend={(question, id) => {
                      appStateContext?.state.isCosmosDBAvailable?.cosmosDB ? makeApiRequest(question, conversationId) : makeApiRequest(question, conversationId)
                    }}
                    conversationId={conversationId}

                  />
                  </Stack>}
              </>}
            </Panel>
            {
              showCitationPanel && (
                <>
                  <Separator className={styles.resizeHolder}/>
                  <Panel defaultSize="40%" minSize="30%">
                    <FilePreview citation={activeCitation} onCloseClick={handleCloseCitationPanel} onTitleClick={onViewSource} agent={selectedAgent} />
                  </Panel>
                </>
              )
            }
            {
              showHistoryPanel && (
                <>
                  <Separator className={styles.resizeHolder}/>
                  <Panel defaultSize="18%" minSize="18%" maxSize="30%">
                    <ChatHistoryPanel onHistoryCleanup={() => resetChatOrNavigateMainPage(selectedAgent)} onHistoryItemRemove={handleHistoryItemRemoved} />
                  </Panel>
                </>
              )
            }

          </PanelGroup>
        </Stack>
      )}
    </div>
  );
};
export default bot